import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DataContextService } from './services/datacontext.service';
import { StartupService } from './services/startup.service';
import { MsalGuard, MsalModule, MsalService } from '@azure/msal-angular';
import { SpinnerComponent } from './common/spinner/spinner.component';
import { SpinnerService } from './common/spinner/spinner.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './common/layout/layout.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './shared/shared.module';
import { DdsConfigModule } from '@usitsdasdesign/dds-ng/shared/dds-config';
import { ToastModule } from '@usitsdasdesign/dds-ng/toast';
import { CommonConfig } from './configs/common.config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PreferencesConfigService } from './services/preferences/preferences-config.service';
import { PreferencesCurrentViewService } from './services/preferences/preferences-current-view';
import { TokenInterceptor } from './services/token.interceptor';
import { AuthGuard } from './guards/auth.guard';
import { MasterDataResolver } from './common/master-data.resolver';
import { ToasterComponent } from './common/toaster/toaster.component';
import { AccessDeniedComponent } from './common/access-denied/access-denied.component';
import { OAuthModule } from 'angular-oauth2-oidc'
import { AuthModule } from './auth.module'

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '../assets/locales/', '.json');
}

export function startupServiceFactory(startupService: StartupService): () => void {
  return () => {
    return startupService
      .authorizeUser()
      .then(() => {
        // return startupService.graphApi();
      })
      .catch((err) => {
        // startupService.loginRedirect();
        // return Promise.reject(err);
      });
  };
}

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    ToasterComponent,
    AccessDeniedComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutModule,
    HttpClientModule,
    BrowserAnimationsModule,
    OAuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedModule,
    DdsConfigModule.forRoot(CommonConfig.ddsConfigOptions),
    MsalModule,
    ToastModule,
    AuthModule
  ],
  providers: [
    DataContextService,
    PreferencesConfigService,
    PreferencesCurrentViewService,
    //MsalService,
    //MsalGuard,
    MasterDataResolver,
    {
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [StartupService],
      multi: true
    },
    AuthGuard,
    SpinnerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
